/**
 * Because this is an extensive list of global variables,
 * use the search function to find the variable you are looking for.
 * The variables are organized by categories based on how they are used.
 *
 * All variable names are named using the following format:
 *      CATEGORY_ITEM
 *
 * For example, the "admin" role would be labeled
 *      ROLE_ADMIN
 * since ROLE describes the category and ADMIN describes the specific role label.
 */

/**
 * Role name constants
 */
export const ROLE_STUDENT = 'student';
export const ROLE_ADMIN = 'admin';

/**
 * Valid email constants
 */
export const CALVIN_EMAIL_SUFFIX = '@calvin.edu';
export const CALVIN_STUDENT_EMAIL_SUFFIX = '@students.calvin.edu';

/**
 * Keyboard key constants
 */
export const KEY_CODE_RETURN = 13; // 13 stands for the return key

/**
 * Button label constants
 */
export const BUTTON_LABEL_CANCEL = 'Cancel';
export const BUTTON_LABEL_VERIFY = 'Verify';

/**
 * Password error message constants
 */
export const ERROR_NO_PASSWORD = 'You must enter a password';
export const ERROR_INVALID_PASSWORD = 'Password is incorrect.';
export const ERROR_PASSWORD_INVALID_LENGTH =
  'Password must be between 6 and 32 characters in length!';
export const ERROR_PASSWORD_MATCH = 'Passwords do not match!';
export const ERROR_PASSWORD_MISC = 'Something went wrong - try again.';
export const ERROR_NOT_LOGGED_IN =
  'You are not currently signed in. Please log out and log back in to try again.';

/**
 * Time constants
 */
export const TWO_DIGIT_CONFIG = '2-digit';

export const HOUR24_TIME_CONFIG: object = {
  hour12: false,
  hour: TWO_DIGIT_CONFIG,
  minute: TWO_DIGIT_CONFIG,
};

export const DATETIME_INPUT_CONFIG: object = {
  hour12: false,
  month: TWO_DIGIT_CONFIG,
  day: TWO_DIGIT_CONFIG,
  year: 'numeric',
  hour: TWO_DIGIT_CONFIG,
  minute: TWO_DIGIT_CONFIG,
};

// Enables 24-hour time and removes seconds from toLocaleString()
export const HOUR24_DATE_CONFIG: object = {
  hour12: false,
  year: TWO_DIGIT_CONFIG,
  month: TWO_DIGIT_CONFIG,
  day: TWO_DIGIT_CONFIG,
  hour: TWO_DIGIT_CONFIG,
  minute: TWO_DIGIT_CONFIG,
};

/**
 * Firestore collection constants
 */
export const COLLECTION_PATIENTS = 'patients';
export const COLLECTION_STUDENT_PATIENTS = 'studentPatients';
export const COLLECTION_USERS = 'users';
export const COLLECTION_MEDICATIONS = 'medications';
export const COLLECTION_DEVELOPERS = 'developers';

/**
 * Patient type constants
 */
export const PATIENT_TYPE_ADULT = 'Adult';
export const PATIENT_TYPE_PEDIATRIC = 'Pediatric';
export const PATIENT_TYPE_OBSTETRIC = 'Obstetric';

/**
 * FormOption constants for Provider/Medication Orders.
 */
export const scheduledOption = 'Scheduled';
export const optionQD = 'QD';
export const optionBID = 'BID';
export const optionTID = 'TID';
export const optionACHS = 'AC/HS';
export const optionPRN = 'PRN';
export const optionSTAT = 'STAT';
export const optionNOW = 'NOW';